import { axios } from "~/plugins/request"
export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  getAllVideoList({ commit }, params) {
		return new Promise((resolve, reject) => {
		  axios.post('video/getAllVideoList', params)
			.then(response => {
			  resolve(response)
			})
			.catch(error => {
			  reject(error)
			})
		})
	},
}
